import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CampaignType } from "@front/m19-api-client";
import { StrategyEx } from "@front/m19-models";
import { AccountSelectionService, SpStrategiesService } from "@front/m19-services";
import { TranslocoDirective } from "@jsverse/transloco";
import { StrategyOverlayComponent } from "@m19-board/overlay/strategy-overlay.component";
import { StrategyAsinsComponent } from "@m19-board/sponsored-product/sp-page/strategy-asins/strategy-asins.component";
import { TargetingAsinStatsComponent } from "@m19-board/sponsored-product/sp-page/targeting-asin-stats/targeting-asin-stats.component";
import { StrategyPageComponent } from "@m19-board/strategies/strategy-page/strategy-page.component";
import { ICON_ADD } from "@m19-board/utils/iconsLabels";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { combineLatest, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";

@UntilDestroy()
@Component({
  selector: "app-sp-page",
  templateUrl: "./sp-page.component.html",
  standalone: true,
  imports: [
    TranslocoDirective,
    StrategyOverlayComponent,
    StrategyPageComponent,
    TargetingAsinStatsComponent,
    StrategyAsinsComponent,
  ],
})
export class SpPageComponent {
  strategy$: Observable<StrategyEx>;
  strategy: StrategyEx | undefined;
  isReadOnly = false;
  brands: Set<string> = new Set();

  readonly CampaignType = CampaignType;

  constructor(
    private route: ActivatedRoute,
    private accountSelectionService: AccountSelectionService,
    private spStrategiesService: SpStrategiesService,
  ) {
    this.strategy$ = combineLatest([
      this.accountSelectionService.singleAccountMarketplaceSelection$,
      this.route.paramMap,
    ]).pipe(
      switchMap(([am, params]) => {
        const id = Number(params.get("id"));
        return this.spStrategiesService
          .getSPStrategies(am.accountId, am.marketplace)
          .pipe(map((strategies) => new StrategyEx(strategies.get(id)!)));
      }),
    );
    this.strategy$.pipe(untilDestroyed(this)).subscribe((s) => {
      this.strategy = s;
    });

    this.accountSelectionService.readOnlyMode$.pipe(untilDestroyed(this)).subscribe((b) => (this.isReadOnly = b));
  }

  protected readonly ICON_ADD = ICON_ADD;
}
